export const addBuilds = (builds = []) => ({
    type: 'ADD_BUILDS',
    payload: {
        builds
    }
});



// WEBPACK FOOTER //
// ./src/actions/app-actions.js